import { LineSheet, LineSheetSetType } from "@/features/line-sheet-sets/line-sheet-set.types";
import { toCamelKeyObject } from "@/utils/case";
import axiosClient, { getAuthTokenFromCookies } from "@/utils/axios-client";

const url = {
  getBuyerFavoriteBrandList: (buyerId: number) =>
    process.env.NEXT_PUBLIC_API_URL + `/buyers/${buyerId}/favorite-brands`,
  saveFavoriteBrand: (buyerId: number) =>
    process.env.NEXT_PUBLIC_API_URL + `/buyers/${buyerId}/favorite-brands`,
  getBuyerFavoriteBrandLineSheetList: (buyerId: number) =>
    process.env.NEXT_PUBLIC_API_URL + `/buyers/${buyerId}/line-sheets/favorite-brands`,
};

export const dashboardFavoriteBrandApi = {
  getFavoriteBrand: (buyerId: number) =>
    axiosClient.get(url.getBuyerFavoriteBrandList(buyerId),{
      headers: {
        Authorization: `Bearer ${getAuthTokenFromCookies()}`,
      },
    }),
  saveFavoriteBrand: (buyerId: number, brandIds: number[]) =>
    axiosClient.put(url.saveFavoriteBrand(buyerId), {
      brand_ids: brandIds,
    },{
      headers: {
        Authorization: `Bearer ${getAuthTokenFromCookies()}`,
      },
    }),
  getFavoriteBrandLineSheetList: (
    buyerId: number,
    lineSheetSetType: LineSheetSetType,
    pageNumber: number = 1,
    pageSize: number = 10,
  ) =>
    axiosClient.get(url.getBuyerFavoriteBrandLineSheetList(buyerId), {
      headers: {
        Authorization: `Bearer ${getAuthTokenFromCookies()}`,
      },
      params: {
        line_sheet_set_type: lineSheetSetType,
        page_size: pageSize,
        page_number: pageNumber,
      },
      transformResponse: [(data) => {
        try {
          const parsed = JSON.parse(data);
          return {
            ...parsed,
            line_sheets: parsed.line_sheets.map((lineSheet: LineSheet) => toCamelKeyObject(lineSheet)),
          };
        } catch (e) {
          console.log(e)
          return data;
        }
      }]
    }
  ),
};
